module.exports = __webpack_public_path__ + "static/media/close-eye-icon.9eecf338.svg";